<template>
  <v-card outlined>
    <v-card-text>
      <h3 class="mb-5">{{ title }}</h3>
      <v-row no-gutters>
        <v-col cols="12" class="mt-10">
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            depressed
            @click="sendCampagne()"
            >{{ $t("Versturen naar") }}
            <span class="font-weight-bold mx-1">{{ amountOfUsers }}</span
            >{{ $t("contactpersonen") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
      
      <script>
export default {
  props: ["amountOfUsers", "title", "urlItem"],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    sendCampagne() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        const toaster = {
          message: "Campagne goed verstuurd",
          timeout: false,
          type: "SUCCESS",
          toastClassName: ["toaster-color-success", "toaster-layout"],
          bodyClassName: ["toaster-text-layout"],
          icon: "mdi-check-circle",
        };
        this.$store.dispatch("setToaster", toaster);
      }, 3000);
    },
  },
};
</script>
      
      <style>
</style>